import { AlertTriangle } from "lucide-react";

const core = (s) => (s || "").replace(/\s*\(.*?\)/g, "").trim().toLowerCase();
const same = (a, b) => core(a) === core(b);

export default function OriginalPanel({ orig, role, items, show, hover, setHover, tid }) {
  if (!orig) return <div className="text-xs text-slate-500" data-testid={`${tid}-orig-missing`}>No original resume found for this job.</div>;
  const usedBy = (i) => items.map((it, n) => (it.origin?.key === `r${i}` ? n : -1)).filter((n) => n >= 0);
  const diffs = [["title", "Title"], ["company", "Company"]].filter(([k]) => !same(orig[k], role[k]));
  return (
    <div className="rounded-lg border border-border bg-slate-950/40 p-3 space-y-2" data-testid={`${tid}-original`}>
      <div className="label-xs">Original resume</div>
      <div className="text-sm text-slate-200">{orig.title} · {orig.company}</div>
      <div className="text-xs text-slate-500">{orig.start} – {orig.end}</div>
      {diffs.length > 0 && (
        <div className="text-xs text-amber-300 flex gap-1.5" data-testid={`${tid}-orig-diff`}><AlertTriangle size={13} className="shrink-0 mt-0.5" />
          {diffs.map(([, l]) => l).join(" and ")} {diffs.length > 1 ? "differ" : "differs"} from the new resume. Official titles and companies must match.</div>
      )}
      <div className="space-y-1.5 pt-1">
        {(orig.bullets || []).filter((b) => b.trim()).map((b, i) => {
          const used = usedBy(i);
          const on = used.some((n) => n < show);
          const lit = hover === `r${i}`;
          return (
            <div key={i} data-testid={`${tid}-orig-${i}`} onMouseEnter={() => setHover(`r${i}`)} onMouseLeave={() => setHover(null)}
              className={`text-[13px] leading-snug p-2 rounded-md border transition-colors ${lit ? "border-blue-500/70 bg-blue-500/10" : "border-transparent"}`}>
              <div className="text-slate-300">{b}</div>
              <div className={`text-[10px] mt-1 uppercase tracking-wider ${on ? "text-emerald-400" : used.length ? "text-slate-500" : "text-amber-400"}`} data-testid={`${tid}-orig-${i}-status`}>
                {used.length ? `Used in ${used.map((n) => `#${n + 1}`).join(", ")}${on ? "" : " (not picked)"}` : "Not used yet"}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
